import React from 'react'
import {getNavigationPaths} from '../../services/navigation'
import {NavLink} from 'react-router-dom'
import classNames from 'classnames'

interface PaymentTabsProps {
  accountId: string
}

function computeTabClasses(isActive: boolean): string {
  return classNames('tab tab-md md:tab-lg tab-lifted', {'tab-active': isActive})
}

const PaymentTabs = ({accountId}: PaymentTabsProps) => {
  const paths = getNavigationPaths(accountId)
  return (
    <div className="tabs mt-4 ml-4">
      <NavLink
        to={paths.MakePayment}
        className={({isActive}) => computeTabClasses(isActive)}
      >
        Make a Payment
      </NavLink>
      <NavLink
        to={paths.PaymentAccounts}
        className={({isActive}) => computeTabClasses(isActive)}
      >
        Payment Accounts
      </NavLink>
      <NavLink
        to={paths.PaymentHistory}
        className={({isActive}) => computeTabClasses(isActive)}
      >
        Payment History
      </NavLink>
    </div>
  )
}

export default PaymentTabs
